import { Accordion, Text } from '@msc-b2c/shared-components';
import React, { useState } from 'react';
import styles from '../stateroomdetails.module.scss';
import { TransferProps } from '@msc-b2c/interfaces/types';

const Transfer: React.FC<TransferProps> = ({
  transferId,
  transferSectionTitle,
  transferSectionIcon,
  viewDetailsLabel,
  openViewDetailsIcon,
  closeViewDetailsIcon,
  transfersData,
}) => {
  const [openId, setOpenId] = useState<string | null>(null);
  return (
    <Accordion
      question={transferSectionTitle}
      answer=""
      isOpen={openId === transferId}
      autoClose={false}
      questionIcon={transferSectionIcon}
      multi={true}
      openingIcon={openViewDetailsIcon}
      closingIcon={closeViewDetailsIcon}
      onToggle={() => setOpenId((prev) => (prev === transferId ? null : transferId))}
      viewDetailsLabel={viewDetailsLabel}
      styleOption={styles.includedWithBookingAccordion}
    >
      {transfersData.map((transfer, index) => (
        <div
          className={styles.transferContainer}
          key={`${transferId}-${index}`}
        >
          {transfer.description && (
            <Text
              text={transfer.description}
              styleOption={styles.transferDescriptionText}
            />
          )}
          {transfer.longDescription && (
            <Text
              text={transfer.longDescription}
              styleOption={styles.transferLongDescriptionText}
            />
          )}
        </div>
      ))}
    </Accordion>
  );
};

export default Transfer;
